import { render, staticRenderFns } from "./MeetingPrintableReportPenaltiesPage.vue?vue&type=template&id=a24ad61e&"
import script from "./MeetingPrintableReportPenaltiesPage.vue?vue&type=script&lang=js&"
export * from "./MeetingPrintableReportPenaltiesPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports